import { CircularProgress, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Grid, Typography, InputAdornment, Switch } from '@mui/material';
import MDButton from 'components/MDButton';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { fetchRefundList, fetchRefundStatus } from '../../../redux/slices/common';
import { useDispatch } from 'react-redux';
import { fetchEmployeesList } from '../../../redux/slices/hyperwolf/settings';
import InfiniteScrollListHandle from 'common/component/Hyperwolf/InfinteScrollHandle';

export default function PaymentRefundReason({ closeModal }) {
    const dispatch = useDispatch()
    const { modalData } = useSelector(state => state.modal);
    const { isgetLoading, employeeData } = useSelector(state => state.hyperwolfSettings);
    const [refundListData, setRefundListData] = useState([]);
    const [errors, setErrors] = useState({});
    const { refundTotal, payOrderStatus, orderId } = modalData || {};
    const [formData, setFormData] = useState({ refundType: '', refundValue: "", cancellationReason: "", amountType: "fullAmount", cancellationReasonOther: "", isInclude: false, employeeId: "", terminalId: "" });
    const { user = {} } = useSelector(state => state.auth);

    const validateAnnouncement = () => {
        let isError = false
        let errors = {}
        if (!formData?.refundType) {
            isError = true
            errors = { ...errors, refundType: 'Refund Type is required' }
        }
        if (formData?.amountType !== 'fullAmount') {
            if (!formData?.refundValue) {
                isError = true
                errors = { ...errors, refundValue: 'Refund Amount is required' }
            }
        }
        if (formData?.cancellationReason === 'Other Reason') {
            if (!formData?.cancellationReasonOther) {
                isError = true
                errors = { ...errors, cancellationReasonOther: 'Other Cancel Reason is required' }
            }
        }
        if (!formData?.cancellationReason) {
            isError = true
            errors = { ...errors, cancellationReason: 'Cancel Reason is required' }
        }
        if (!formData?.employeeId) {
            isError = true
            errors = { ...errors, employees: 'Employee ID is required' }
        }
        // if (formData?.refundValue > refundTotal) {
        //     isError = true
        //     errors = { ...errors, refundValue: `Custom amount can't be greater than the total amount` }
        // }

        return { errors, isError }
    }


    const submitHandler = () => {
        const { isError, errors } = validateAnnouncement()
        setErrors(errors)
        if (isError) return;
        setErrors({})

        const payload = {
            cancellationReason: formData?.cancellationReason === 'Other Reason' ? formData?.cancellationReasonOther : formData?.cancellationReason,
            orderId: orderId,
            employeeId: formData?.employeeId,
            terminalId: formData?.terminalId,
            updatedBy: user?.name,
        }
        if (formData?.refundType !== 'norefund') {
            payload.refundType = formData?.refundType;
            payload.refundValue = formData?.amountType === 'fullAmount' ? refundTotal : formData?.refundValue;
        }

        payOrderStatus(payload);
    };


    const startTaskHandler = (e, type) => {
        const { name, value, checked } = e.target;

        if (type === 'refundValue') {
            if (value > refundTotal) {
                setErrors({
                    ...errors,
                    refundValue: `Custom amount can't be greater than the total amount`
                })
                return false
            }
        }

        if (type === 'toggle') {
            setFormData({
                ...formData,
                [name]: checked
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
        setErrors({
            ...errors,
            [name]: ""
        });
    };

    useEffect(() => {
        dispatch(fetchRefundList()).unwrap().then((res) => {
            setRefundListData(res?.refundReasons)
        });
        // dispatch(fetchEmployeesList()).unwrap().then((res) => {
        //     setEmployeesList(res?.data?.employees)
        // }).catch((err) => {
        //     setEmployeesList([])

        // });
    }, [])


    // useEffect(() => {
    //     if (formData.amountType === 'fullAmount') {
    //         setFormData({
    //             ...formData,
    //             refundValue: "",
    //             isInclude: false
    //         })
    //     }
    // }, [formData])
    const driverSelectHandler = useCallback(driver => {

        setFormData(prevState => ({
            ...prevState,
            employeeId: driver // Update form data with selected driver
        }));
    }, []);

    // Memoized list of options for the driver select dropdown
    const optionsList = useMemo(() => {
        return employeeData?.map(driver => ({
            value: driver.employeeId, // The value to be submitted
            label: driver.name, // The display label in the dropdown
            terminalId: driver.terminalId, // The value to be submitted
        })) || [];
    }, [employeeData]);

    return (
        <div className="refund-process-inner">
            <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between'>
                Process Refund

                <IconButton onClick={closeModal} edge='end' size='small'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} xl={12} className="select-refound-label">
                        <FormControl fullWidth>
                            <InputLabel>Select Method</InputLabel>
                            <Select
                                size='large'
                                value={formData?.refundType} onChange={(e) => { startTaskHandler(e) }} fullWidth
                                className='form-select'
                                name='refundType'
                                label='Product Status'
                                MenuProps={{ className: 'refund-popover' }}
                            >
                                <MenuItem value='wallet'>Wallet</MenuItem>
                                <MenuItem value='originalMethod'>Original Payment Method</MenuItem>
                                <MenuItem value='norefund'>No Refund</MenuItem>
                            </Select>
                            <p className="error">
                                {errors?.refundType}
                            </p>
                        </FormControl>
                    </Grid>
                    {/* {
                        formData?.refundType !== 'norefund' &&
                        <Grid item xs={12} sm={12} xl={12}>
                            <FormControl fullWidth>
                                <RadioGroup
                                    row
                                    aria-labelledby='demo-row-radio-buttons-group-label'
                                    name='amountType'
                                    value={formData?.amountType}
                                    onChange={(e) => startTaskHandler(e)}
                                    className='modal-radio text-black-600'
                                >
                                    <FormControlLabel value='fullAmount' className='text-black-600' control={<Radio />} label='Full Amount' />
                                    <FormControlLabel value='customAmount' className='text-black-600' control={<Radio />} label='Custom Amount' />
                                </RadioGroup>
                            </FormControl>
                            Max: {refundTotal ? `$${refundTotal}` : '$0.00'}

                        </Grid>
                    } */}
                    {
                        formData?.refundType !== 'norefund' &&
                        <>
                            {
                                formData?.amountType === 'customAmount' ?
                                    <Grid item xs={12} sm={12} xl={12}>
                                        <FormControl fullWidth>

                                            <TextField
                                                fullWidth
                                                error={Boolean(errors?.refundValue)}
                                                helperText={errors?.refundValue}
                                                className='form-input'
                                                value={formData?.refundValue || ''}
                                                onChange={(e) => {
                                                    // Ensure only numeric input
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {  // Regex to allow digits and decimals
                                                        startTaskHandler(e, "refundValue");
                                                    }
                                                }}
                                                label='Amount'
                                                name='refundValue'
                                                type='text'  // Use text so you can apply the regex validation
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,  // Adding the "$" symbol
                                                }}
                                                inputProps={{
                                                    inputMode: 'numeric',  // This will help mobile keyboards show only numeric input
                                                    pattern: '[0-9]*',  // This ensures the input is only numbers in case of mobile
                                                }}
                                            />

                                        </FormControl>
                                    </Grid>
                                    :
                                    <Grid item xs={12} sm={12} xl={12}>
                                        <FormControl fullWidth>
                                            <TextField
                                                fullWidth
                                                className='form-input'
                                                value={refundTotal} onChange={(e) => startTaskHandler(e)}
                                                label='Amount'
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                }}
                                                name='refundValue'
                                                disabled
                                            />
                                        </FormControl>
                                    </Grid>
                            }
                        </>
                    }

                    <Grid item xs={12} sm={12} xl={12} mb={2}>
                        <Typography variant='h6' fontWeight="semibold" mb={1}>Add Reason</Typography>
                        <FormControl fullWidth>
                            <InputLabel>Add Reason</InputLabel>
                            <Select
                                size='large'
                                fullWidth
                                className='form-select'
                                name='cancellationReason'
                                sx={{
                                    '& .MuiSelect-select': {
                                        paddingRight: "2rem !important",
                                        width: "calc(100% - 90px)"
                                    }
                                }}
                                value={formData?.cancellationReason} onChange={(e) => { startTaskHandler(e) }}
                                label='Add Reason'
                                MenuProps={{ className: 'refund-popover' }}
                            >
                                {
                                    refundListData?.map((data, idx) => {
                                        return (
                                            <MenuItem key={idx} value={data?.refundReason}>{data?.refundReason}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            <p className="error">
                                {errors?.cancellationReason}
                            </p>
                        </FormControl>
                    </Grid>
                    {
                        formData?.cancellationReason === 'Other Reason' &&
                        <Grid item xs={12} sm={12} xl={12} mb={2}>
                            <FormControl fullWidth>
                                <TextField
                                    fullWidth
                                    error={Boolean(errors?.cancellationReasonOther)}
                                    helperText={errors?.cancellationReasonOther}
                                    className='form-input'
                                    label='Add other Reason'
                                    name='cancellationReasonOther'
                                    onChange={(e) => { startTaskHandler(e) }}
                                    multiline
                                    rows={4}
                                />
                            </FormControl>
                        </Grid>
                    }
                </Grid>
                {/* 
                <Grid item xs={12} sm={4} md={4} xxl={2}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant='h6' fontWeight="semibold" mb={1}>Employees</Typography>
                        <FormControl fullWidth>
                            <InputLabel>Employees</InputLabel>
                            <Select
                                size='large'
                                fullWidth
                                className='form-select'
                                name='employeeId'
                                sx={{
                                    '& .MuiSelect-select': {
                                        paddingRight: "2rem !important",
                                        width: "calc(100% - 90px)"
                                    }
                                }}
                                value={formData?.employeeId}
                                // onChange={(e) => { startTaskHandler(e) }}
                                label='Add Reason'
                                MenuProps={{ className: 'refund-popover' }}

                                onChange={(e) => {
                                    const selectedEmployee = employeesList.find(emp => emp?.employeeId === e.target.value);

                                    setFormData(prev => ({
                                        ...prev,
                                        employeeId: e.target.value,
                                        terminalId: selectedEmployee?.terminalId
                                    }));
                                    // startTaskHandler(e);
                                    // startTaskHandler({
                                    //     target: {
                                    //         name: e.target.name,
                                    //         value: e.target.value
                                    //     }
                                    // }, 'employee', selectedEmployee);
                                }}
                            >
                                {
                                    employeesList?.map((data, idx) => {
                                        return (
                                            <MenuItem key={idx} value={data?.employeeId}>{data?.name}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            <p className="error">
                                {errors?.employees}
                            </p>
                        </FormControl>
                    </Grid>

                </Grid> */}
                <InfiniteScrollListHandle error={errors} dataFetcher={fetchEmployeesList} optionSelectHandler={driverSelectHandler} options={optionsList} value={formData?.employeeId} label='Select Employee' setFormData={setFormData} formData={formData} />
                <p className="error">
                    {errors?.employees}
                </p>
            </DialogContent>
            <DialogActions>
                <MDButton
                    onClick={submitHandler}
                    size='large'
                    color='primary'
                    disabled={isgetLoading}
                    sx={{ minWidth: '150px', padding: '0.25rem 1.5rem' }}
                >
                    {isgetLoading ? <CircularProgress size={16} color='light' /> : 'Save'}
                </MDButton>
                <MDButton
                    onClick={closeModal}
                    size='large'
                    variant='outlined'
                    color='dark'
                    sx={{ minWidth: '150px', padding: '0.25rem 1.5rem' }}
                >
                    Cancel
                </MDButton>
            </DialogActions>
        </div>
    );
}